import { dealTypeFromJsonQuery, getTermsValue, isDailyrent, resetTerms, setTerms } from '../../../../JsonQuery';
import { TTagsManager } from '../../types/tag';
import { PARKING_TYPES_MAP_VALUE_TO_LABEL } from './constants';
import { EParkingType } from '../../../../api-models/common/json_query';
import { createTagValue } from '../../utils/createTagValue';

const ID = 'parkingType' as const;
/** В посуточной «Парковка» - опция в «Удобствах»: пишет все типы разом, показываем одним тегом, как остальные удобства */
const DAILYRENT_PARKING_TAG_VALUE = 'dailyrent';

export const parkingTypeTagsManager: TTagsManager = {
  id: ID,
  extractTagsFromJsonQuery: ({ jsonQuery }) => {
    const parkingTypes = getTermsValue('parking_type')(jsonQuery);

    if (parkingTypes === null) {
      return null;
    }

    if (isDailyrent(dealTypeFromJsonQuery(jsonQuery))) {
      return [{ label: 'Парковка', value: createTagValue(ID, DAILYRENT_PARKING_TAG_VALUE) }];
    }

    if (parkingTypes.includes(EParkingType.Rooftop)) {
      return null;
    }

    return parkingTypes.map(parkingType => ({
      label: `${PARKING_TYPES_MAP_VALUE_TO_LABEL[parkingType]} парковка`,
      value: createTagValue(ID, parkingType.toString()),
    }));
  },
  modifyJsonQueryByRemovingTag: ({ jsonQuery, removingTagValue }) => {
    const parkingTypes = getTermsValue('parking_type')(jsonQuery);

    if (parkingTypes === null) {
      return jsonQuery;
    }

    // как снятие галки «Парковка» в «Удобствах»: setParkingType(null)
    if (removingTagValue === DAILYRENT_PARKING_TAG_VALUE) {
      return resetTerms(['parking_type'])(jsonQuery);
    }

    const newParkingTypes = parkingTypes.filter(parkingType => parkingType !== EParkingType.Rooftop);

    return newParkingTypes.length
      ? setTerms('parking_type')(jsonQuery)(newParkingTypes)
      : resetTerms(['parking_type'])(jsonQuery);
  },
};
